import au from './items/au';
import br from './items/br';
import ca from './items/ca';
import cn from './items/cn';
import de from './items/de';
import es from './items/es';
import eu from './items/eu';
import fr from './items/fr';
import it from './items/it';
import jp from './items/jp';
import kr from './items/kr';
import mx from './items/mx';
import ph from './items/ph';
import sa from './items/sa';
import tw from './items/tw';
import uk from './items/uk';
import us from './items/us';
import za from './items/za';
import nl from './items/nl';
import global from './items/global';

export type Locale = {
    locale: string;
    conver?: string;
    appId?: number | string;
    acceptLanguage?: string;
};
export const localeObj = {
    us,
    cn,
    ca,
    au,
    eu,
    uk,
    de,
    fr,
    it,
    es,
    nl,
    jp,
    za,
    kr,
    sa,
    tw,
    br,
    mx,
    ph,
    global,
};

export type LocalesType = keyof typeof localeObj;

export const localeObjList = Object.values(localeObj);

export const defaultLocale = 'us';

// 获取国家列表;['us', 'ca']
export const localeList = localeObjList.map((item: any) => {
    return item.locale;
});

// 根据 locale 获取选中的国家obj值
export const getLocalObj = (locale: string) => {
    const list = localeObjList.filter((item: Locale) => {
        return item.locale == locale;
    });
    return list[0] || localeObjList[0];
};
